import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import CustomerAdvertisingAgentAgreementContent from "../../components/CustomerAdvertisingAgentAgreement/CustomerAdvertisingAgentAgreement";

const CustomerAdvertisingAgentAgreement = () => {
  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <PageTitle
            pageTitle={"Becoming Customer Advertising Agent Agreement"}
            pagesub={"Home"}
          />
          <CustomerAdvertisingAgentAgreementContent />
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};

export default CustomerAdvertisingAgentAgreement;

